import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {DELETE_MODE, EDIT_MODE, VIEW_MODE} from "../constants";
import {Button, FormControl} from "react-bootstrap";
import {savePredefinedText} from "../../redux/actions";
import PropertyDefinitionSelect from "../reusables/PropertyDefinitionSelect";
import ValueSelect from "../reusables/ValueSelect";
import ValueRender from "../reusables/ValueRender";
import {allowedTargetTypesForPredefinedTexts} from "./AddPredefinedText";
import PropTypes from "prop-types";

class PredefinedTextTableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customerId: this.props.customerId,
            mode: typeof props.mode !== "undefined" ? props.mode : VIEW_MODE,
            text: this.props.text
        }
    }

    componentDidUpdate() {

    }

    startEdit(e) {
        e.preventDefault();
        this.setState({mode: EDIT_MODE})
    }

    cancelEdit(e) {
        e.preventDefault();
        this.setState({
            text: this.props.text,
            mode: VIEW_MODE
        })
    }

    saveEdit(e) {
        e.preventDefault();
        this.setState({mode: VIEW_MODE});
        this.props.dispatch(savePredefinedText({
            predefinedText: this.state.text,
            customerId: this.state.customerId,
            mode: this.state.mode
        }))
    }

    deleteText(e) {
        e.preventDefault();
        this.setState({deleting: true});
    }

    cancelDelete(e) {
        e.preventDefault();
        this.setState({deleting: false})
    }

    confirmDelete(e) {
        e.preventDefault();
        this.setState({mode: VIEW_MODE, deleting: false});
        this.props.dispatch(savePredefinedText({
            predefinedText: this.state.text,
            customerId: this.state.customerId,
            mode: DELETE_MODE
        }))
    }

    propertyDescription(propertyDefinitionId) {
        let pd = this.propertyDefinitionById(propertyDefinitionId);
        if (pd) {
            return pd.description;
        }
        else {
            return propertyDefinitionId;
        }
    }

    propertyDefinitionById(id) {
        if (this.props.propertyDefinitions && this.props.propertyDefinitions[this.props.customerId] &&
            this.props.propertyDefinitions[this.props.customerId].data) {
            return this.props.propertyDefinitions[this.props.customerId].data.filter(entry => entry.id === id)[0];
        }
        else {
            return {};
        }
    }

    triggerValueChanged(v) {
        this.setState({text: {...this.state.text, triggerValue: v}});
    }

    targetValueChanged(v) {
        this.setState({text: {...this.state.text, targetValue: v}});
    }


    targetPropertyChanged(pd) {
        let selectValues = Object.keys(pd.possibleValues);
        this.setState({
            text: {
                ...this.state.text,
                targetProperty: pd.id,
                targetValue: selectValues.length > 0 ? selectValues[0] : this.state.text.targetValue
            }
        })
    }

    triggerPropertyChanged(pd) {
        if(pd) {
            let selectValues = Object.keys(pd.possibleValues);
            this.setState({
                text: {
                    ...this.state.text,
                    triggerProperty: pd.id,
                    triggerValue: selectValues.length > 0 ? selectValues[0] : this.state.text.triggerValue
            }})
        }
        else {
            this.setState({text: {
                ...this.state.text,
                triggerProperty: null,
                triggerValue: null
            }})
        }

    }

    nameChanged(e) {
        this.setState({text: {...this.state.text, name: e.target.value}});
    }

    typeChanged(e) {
        this.setState({text: {...this.state.text, type: e.target.value}});
    }

    getStyle() {
        if (this.state.deleting) {
            return {backgroundColor: 'indianred'}
        }
        else {
            return {};
        }
    }

    renderUnconditional() {
        return <span style={{"color":"lightgray"}}>Unconditional</span>;
    }

    render() {
        return (
            this.state.mode === VIEW_MODE ?
                <tr onClick={e => this.startEdit(e)}>
                    <td className="pre">
                        {this.state.text.triggerProperty ? this.propertyDescription(this.state.text.triggerProperty) : this.renderUnconditional()}
                    </td>
                    <td className="pre-line">
                        {this.state.text.triggerValue ? <ValueRender
                            propertyDefinition={this.propertyDefinitionById(this.state.text.triggerProperty)}
                            value={this.state.text.triggerValue} renderAttribute="description"
                        /> : this.renderUnconditional()}
                    </td>
                    <td className="pre">
                        {this.propertyDescription(this.state.text.targetProperty)}
                    </td>
                    <td className="pre-line">
                        <ValueRender
                            propertyDefinition={this.propertyDefinitionById(this.state.text.targetProperty)}
                            value={this.state.text.targetValue} renderAttribute="description"
                        />
                    </td>
                    <td className="pre-line">{this.state.text.name}</td>
                    <td className="pre-line">{this.state.text.type}</td>
                </tr>
                :
                <tr className="table-row-edit" style={this.getStyle()}>
                    <td className="pre">
                        <PropertyDefinitionSelect customerId={this.props.customerId}
                                                  selectedId={this.state.text.triggerProperty}
                                                  displayWhenEmpty={"Unconditional"}
                                                  allowEmpty={this.props.allowUnconditional}
                                                  onChange={e => this.triggerPropertyChanged(e)}/>
                    </td>
                    <td className="pre-line">
                        <ValueSelect propertyDefinition={this.propertyDefinitionById(this.state.text.triggerProperty)}
                                     value={this.state.text.triggerValue}
                                     onChange={v => this.triggerValueChanged(v)}/>
                    </td>
                    <td className="pre">
                        <PropertyDefinitionSelect customerId={this.props.customerId}
                                                  allowPropertyTypes={allowedTargetTypesForPredefinedTexts}
                                                  selectedId={this.state.text.targetProperty}
                                                  onChange={e => this.targetPropertyChanged(e)}/>
                    </td>
                    <td className="pre-line">
                        <ValueSelect propertyDefinition={this.propertyDefinitionById(this.state.text.targetProperty)}
                                     value={this.state.text.targetValue}
                                     onChange={v => this.targetValueChanged(v)}/>
                    </td>

                    <td className="pre-line">
                        <FormControl value={this.state.text.name} onChange={e => this.nameChanged(e)}
                                     type="text" placeholder="Name of the text"/>
                    </td>

                    <td className="pre-line" colSpan="100%">
                        <FormControl value={this.state.text.type} onChange={e => this.typeChanged(e)}
                                     type="text" placeholder="Type of the text"/>
                    </td>

                    <td className="table-row-edit-buttons">
                        {!this.state.deleting && <Button onClick={e => this.cancelEdit(e)}>
                            <i className="fas fa-times"/>
                        </Button>}
                        {!this.state.deleting && <Button onClick={e => this.deleteText(e)}>
                            <i className="far fa-trash-alt"/>
                        </Button>}
                        {!this.state.deleting && <Button onClick={e => this.saveEdit(e)}>
                            <i className="far fa-save"/>
                        </Button>}


                        {this.state.deleting &&
                        <Button onClick={e => this.cancelDelete(e)}>
                            <i className="fas fa-times"/>
                        </Button>
                        }

                        {this.state.deleting &&
                        <Button onClick={e => this.confirmDelete(e)}>
                            <i className="fas fa-trash-alt"/>
                        </Button>
                        }
                    </td>
                </tr>
        );
    }
}

PredefinedTextTableRow.propTypes = {
    customerId: PropTypes.string.isRequired,
    text: PropTypes.object.isRequired,
    allowUnconditional: PropTypes.bool.isRequired,
};

const mapStateToProps = state => {
    return {
        pendingCalls: state.pendingCalls, customer: state.currentCustomer,
        propertyDefinitions: state.propertyDefinitions
    };
};

const mapDispatchToProps = (dispatch) => ({dispatch});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PredefinedTextTableRow));



// WEBPACK FOOTER //
// ./src/components/predefined-text/PredefinedTextTableRow.js